<template>
  <Appendix
    title="Phụ lục bổ sung"
    :fields="fieldsTable"
    :actions="actions"
    :excepts="excepts"
    :only="only"
    :items="items"
    :contract="contract"
  >
    <template #row-details="item">
      <p v-if="item.appraisalStatus">
        Tình trạng thẩm định MPOS:
        {{ item.appraisalStatus | transformData(Config.statusDeterminedMpos) }}
      </p>
      <p v-if="item.appraiser">Người thẩm định/yêu cầu bổ sung: {{ item.appraiser }}</p>
      <p v-if="item.appraisalTime">
        Thời gian thẩm định/yêu cầu bổ sung:
        {{ item.appraisalTime | formatDate('HH:mm, DD/MM/YYYY') }}
      </p>
      {{ item.motoType }}
    </template>

    <template #file="item">
      <div class="form-detail">
        <UploadMultiple
          v-if="item.urlPDF"
          :lsData="[item]"
          keyUrl="urlPDF"
          :canUpload="false"
          :title="`File phụ lục ${item.code}`"
          titleTag="h1"
          titleClass="form-inner-heading"
        />
        <UploadMultiple
          v-if="item.appendixMultiFunctional.multiFunctionalImages"
          :lsData="item.appendixMultiFunctional.multiFunctionalImages"
          :canUpload="false"
          title="Ảnh giải trình"
        />
        <span v-if="item.appendixMultiFunctional.note" class="txt-bold"
          >Ghi chú: {{ item.appendixMultiFunctional.note }}</span
        >
      </div>
    </template>
  </Appendix>
</template>
<script>
  import Config from '@/thirdParty/config'
  import Appendix from './Appendix.vue'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  export default {
    props: {
      actions: {
        type: Function,
      },
      excepts: {
        type: Array,
        default: () => [],
      },
      only: {
        type: Array,
        default: () => [],
      },
      items: {
        type: Array,
        default: () => [],
      },
      contract: {
        type: Object,
        default: () => {},
      },
    },
    components: { Appendix, UploadMultiple },
    data() {
      return {
        fieldsTable: [
          { key: 'code', label: 'Số phụ lục', class: 'text-left' },
          {
            key: 'appendixMultiFunctional.functionType',
            label: 'Loại phụ lục',
            class: 'text-left',
          },
          {
            key: 'time',
            label: 'Thời gian',
            class: 'text-left',
            thStyle: 'min-width: 210px',
          },
          { key: 'state', label: 'Trạng thái', class: 'text-center' },
          { key: 'mposStt', label: 'TT MPOS', class: 'text-center' },
          { key: 'action', label: 'Thao tác', class: 'text-center' },
        ],
        Config,
      }
    },
  }
</script>

<style scoped></style>
